import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-tai-chi-walking-v2': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-v2&exp=web_tai_chi_walking_fem_v2_input_screens_before_paywall~1
			funnel: {
				id: 'ob-female-tai-chi-walking-v2-input-screens-before-paywall',
				locale: ['en'],
			},
		},
	},
]

export default config
